import React, { Component } from "react";
import "./SalesTotalByPeriodWidget.scss";
import { NumericFormat } from "react-number-format";
import SalesTotalTypeEnum from "../../../models/SalesTotalTypeEnum";
import { OwIconButton } from "../../shared/OwIconButton/OwIconButton";
import OwLabel from "../../shared/OwLabel/OwLabel";
import UserTypesEnum from "../../../models/UserTypesEnum";

type Props = {
    type: SalesTotalTypeEnum;
    amount: number;
    removeWidget?: () => void;
    inEditor?: boolean;
};

export const SalesTotalByPeriodWidget = (props: Props) => {
    return (
        <div className={"SalesTotalByPeriodWidget widget"}>
            {props.inEditor ? (
                <div className={""}>
                    <OwIconButton iconClass={"fas fa-trash-alt"} iconColorClass={"text-danger"} fn={props.removeWidget!} />
                </div>
            ) : null}
            <div className={"period-title"}>
                <OwLabel title={`${props.type}_sales`} noBottomMargin={true} />
            </div>
            <div className={"sales-total"}>
                <NumericFormat
                    value={props.amount}
                    displayType={"text"}
                    thousandSeparator={true}
                    decimalScale={2}
                    fixedDecimalScale={true}
                    prefix={"$"}
                />
            </div>
        </div>
    );
};
